import React from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Col, Container, Row } from 'react-bootstrap';

const NotFound = () => {
  return (
    <Container className="py-5">
      <Alert variant="warning" className="text-center">
        {/* <p className="mb-3">URL not defined</p> */}
        <Row className="justify-content-center mb-3">
            <Col xs="auto">
                <p className="mb-4">The page you are trying to access does not exist.</p>        
            </Col>
        </Row>
        <Row className="justify-content-center mb-3">
            <Col xs="auto">
                <Button as={Link} to="/" variant="primary">
                    Go to Home
                </Button>
            </Col>
        </Row>
      </Alert>
    </Container>
  );
};

export default NotFound;
